export interface SimuladorState {
    resultado: any | null;
    tipos: any[];
    pisos: number[];
    cuota_inicial: number[];
}

export const state: SimuladorState = {
    resultado: null,
    tipos: [],
    pisos: [],
    cuota_inicial: [],
};